import { render, staticRenderFns } from "./NotificationTabs.vue?vue&type=template&id=2daee4ae&scoped=true"
import script from "./NotificationTabs.vue?vue&type=script&lang=js"
export * from "./NotificationTabs.vue?vue&type=script&lang=js"
import style0 from "./NotificationTabs.vue?vue&type=style&index=0&id=2daee4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daee4ae",
  null
  
)

export default component.exports